import React from "react";
interface  GalleryImage {
  image:string;
  id:number
  key:number
}
const DisplayCalleryImage = ({ key, image, id, onDelete }: GalleryImage & { onDelete: (id: number) => void; }) => {
  const handleDeleteGallery = () => {
    onDelete(id);
  };
  return (
    <div key={key} className="component-display-gallery-image">
      <div className="delete" onClick={handleDeleteGallery}>x</div>
      <img src={`https://api.leblr.fr${image}`} alt="" />
    </div>
  );
};

export default DisplayCalleryImage;